import { render, staticRenderFns } from "./BankTransaction.vue?vue&type=template&id=7bb56d80&"
import script from "./BankTransaction.vue?vue&type=script&lang=js&"
export * from "./BankTransaction.vue?vue&type=script&lang=js&"
import style0 from "./BankTransaction.vue?vue&type=style&index=0&id=7bb56d80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports